import React, { useCallback, useEffect, useState } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { useSelector } from "react-redux";
import TimeEntries from "../../store/timeEntries/reducer";
import moment from "moment";

const TimeTrackingDropdownTimerHelper = ({
  Rseconds,
  Rminutes,
  Rhours,
  handleStartTimer,
  clockSize,
}) => {
  const {
    rTimeEntryStartDateTime,
    rTimeEntryEndDateTime,
    rtimerIsRunning,
    rPauseTimer,
  } = useSelector((state) => ({
    rTimeEntryStartDateTime:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryStartDateTime,
    rTimeEntryEndDateTime:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryEndDateTime,
    rtimerIsRunning:
      state.TimeEntries.timeEntryData.timeentry_data.timerIsRunning,
    rPauseTimer: state.TimeEntries.timeEntryData.timeentry_data.pauseTimer,
  }));

  const [seconds, setSeconds] = useState(Rseconds);
  const [minutes, setMinutes] = useState(Rminutes);
  const [hours, setHours] = useState(Rhours);

  useEffect(() => {
    if (!rtimerIsRunning) {
      //delay the timer
      setTimeout(() => {
        setSeconds(Rseconds);
        setMinutes(Rminutes);
        setHours(Rhours);
      }, 300);
    }
  }, [rtimerIsRunning]);
  // Task 24876. The clock is DERIVED from the start time, never accumulated.
  //
  // It used to tick by doing seconds + 1 on a setInterval. Chrome throttles
  // timers in a background tab to about one a minute, and freezes them outright
  // in a discarded one, so the count fell behind the wall clock - come back
  // after a while and the timer was reading twenty minutes light. The dropdown
  // already refetches the open entry when the tab becomes visible again, but
  // the server hands back the SAME start time, so nothing this component
  // watched had changed and the drifted count carried on from where it was.
  //
  // Recomputing from the start time means throttling can only make the display
  // update less often. Whenever it does update, it is right.
  const syncFromClock = useCallback(() => {
    if (!rTimeEntryStartDateTime || rTimeEntryStartDateTime === "today") return;

    const end = rTimeEntryEndDateTime
      ? moment(rTimeEntryEndDateTime)
      : moment();
    let diff = end.diff(moment(rTimeEntryStartDateTime));
    // A start time in the future - clock skew between here and the server -
    // would otherwise render as a negative countdown.
    if (!Number.isFinite(diff) || diff < 0) diff = 0;

    setHours(Math.floor(diff / 3600000));
    setMinutes(Math.floor((diff % 3600000) / 60000));
    setSeconds(Math.floor(((diff % 3600000) % 60000) / 1000));
  }, [rTimeEntryStartDateTime, rTimeEntryEndDateTime]);

  useEffect(() => {
    syncFromClock();
  }, [syncFromClock]);

  useEffect(() => {
    // Paused keeps the display where it is, which is what it did before.
    if (!rtimerIsRunning || rTimeEntryEndDateTime !== "" || rPauseTimer) {
      return undefined;
    }

    syncFromClock();
    const interval = setInterval(syncFromClock, 1000);

    // Belt and braces for the moment the tab wakes: a frozen tab does not get
    // its interval back until the browser decides to give it back, and waiting
    // even a second to stop showing a wrong number is a second too long.
    const resync = () => {
      if (document.visibilityState === "visible") syncFromClock();
    };
    document.addEventListener("visibilitychange", resync);
    window.addEventListener("focus", resync);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", resync);
      window.removeEventListener("focus", resync);
    };
  }, [rtimerIsRunning, rTimeEntryEndDateTime, rPauseTimer, syncFromClock]);

  // if rPauseTimer is true then pause the timer

  return (
    <>
      <div
        style={{
          width: clockSize === "icon" ? 25 : 75,
          height: clockSize === "icon" ? 25 : 75,
        }}
      >
        <CircularProgressbarWithChildren
          minValue={0}
          maxValue={60}
          value={seconds}
          strokeWidth={8}
          styles={buildStyles({
            pathColor: "#13C56B",
            trailColor: "#E7F9F0",
            backgroundColor: "#E7F9F0",
          })}
        >
          {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
          {/*<img style={{ width: 40, marginTop: -5 }} src="https://i.imgur.com/b9NyUGm.png" alt="doge" />*/}
          {clockSize !== "icon" ? (
            <>
              {rtimerIsRunning ? (
                <>
                  {hours > 0 ? (
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <span>{hours} </span>
                      <strong>H</strong>
                    </div>
                  ) : null}
                  {minutes > 0 ? (
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <span>{minutes} </span>
                      <strong>M</strong>
                    </div>
                  ) : null}
                  <div style={{ fontSize: 12, marginTop: -5 }}>
                    <span>{seconds} </span>
                    <strong>S</strong>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    fontSize: 14,
                    marginTop: -5,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleStartTimer();
                  }}
                >
                  <span>
                    <i className="fa-solid fa-play"></i>
                  </span>
                </div>
              )}
            </>
          ) : (
            <>
              <i className="fa-regular fa-clock fa-beat-fade fs-10"></i>
            </>
          )}
        </CircularProgressbarWithChildren>
      </div>
    </>
  );
};

export default TimeTrackingDropdownTimerHelper;
